import { indexBy } from '../utils/indexBy';
const indexByPipelineId = indexBy(({
  pipelineId: id
}) => id);
export class PipelinesCache {
  constructor() {
    this.cache = {};
  }

  get({
    objectTypeId,
    httpClient
  }) {
    const cachedPromise = this.cache[objectTypeId];

    if (cachedPromise) {
      return cachedPromise;
    }

    const promise = httpClient.get(`/pipelines/v2/pipelines/${encodeURIComponent(objectTypeId)}`).then(pipelines => indexByPipelineId(pipelines));
    this.cache[objectTypeId] = promise;
    return promise;
  }

  clear() {
    this.cache = {};
  }

}